import { condensateViscositiesCalculator as beggsRobinson } from "./beggsRobinson";

import type {
  CondensateViscosityCorrelations,
  CondensateViscosityParameters
} from "../d";
import type { Correlations } from "@/composables/forms/formTypes";
import type { BasicData } from "@/libs/calculations/fluidProperties/d";
import { Rankine } from "@/libs/units/temperature";

// PVT!BJ54:BJ68 — Beggs and Robinson is the only condensate viscosity correlation in the sheet
const condensateViscosityCalculator = beggsRobinson;

export function getCondensateViscosityCorrelations(
  basicData: BasicData,
  gasOilRatio: number,
  correlations: Correlations,
  inSituPressurePSIA: number,
  temperatureF: number,
  condensateSpecificGravity: number,
  solutionGasRso: number,
  dewPointPressurePSIA: number
): CondensateViscosityCorrelations {
  const params: CondensateViscosityParameters = {
    temperatureF,
    gasSpecificGravity: basicData.gasSpecificGravity,
    surfaceTemperatureF: basicData.surfaceTemperatureF,
    datumTempF: basicData.bottomholeTemperatureF,
    tubingPressurePSIA: basicData.bottomTubingPressurePSIA,
    inSituPressurePSIA,
    solutionGasRso,
    bubblePointPressurePSIA: dewPointPressurePSIA,
    temperatureInRankine: Rankine.toThisUnit(temperatureF),
    reservoirPressurePSIA: basicData.staticBottomholePressurePSIA,
    gasOilRatio,
    condensateSpecificGravity,
    gasType: basicData.gasType,
    sourceParams: {
      basicData,
      gasOilRatio,
      correlations,
      inSituPressurePSIA,
      temperatureF,
      bubblePointPressurePSIA: dewPointPressurePSIA
    }
  };

  const { deadCondensateViscosity, ...deadCondensateViscosityIntermediates } =
    condensateViscosityCalculator.deadCondensateViscosityCalculator(params);

  const {
    saturatedCondensateViscosity,
    ...saturatedCondensateViscosityIntermediates
  } = condensateViscosityCalculator.saturatedCondensateViscosityCalculator({
    ...params,
    ...deadCondensateViscosityIntermediates,
    deadCondensateViscosity
  });

  const {
    undersaturatedCondensateViscosity,
    ...underSaturatedCondensateViscosityIntermediates
  } = condensateViscosityCalculator.underSaturatedCondensateViscosityCalculator(
    {
      ...params,
      ...deadCondensateViscosityIntermediates,
      ...saturatedCondensateViscosityIntermediates,
      deadCondensateViscosity,
      saturatedCondensateViscosity
    }
  );

  const condensateViscosityCP =
    inSituPressurePSIA > dewPointPressurePSIA && dewPointPressurePSIA > 0
      ? undersaturatedCondensateViscosity
      : saturatedCondensateViscosity;

  return {
    deadCondensateViscosityCP: deadCondensateViscosity,
    saturatedCondensateViscosityCP: saturatedCondensateViscosity,
    underSaturatedCondensateViscosityCP: undersaturatedCondensateViscosity,
    condensateViscosityCP,
    intermediates: {
      deadCondensateViscosity: deadCondensateViscosityIntermediates,
      saturatedCondensateViscosity: saturatedCondensateViscosityIntermediates,
      underSaturatedCondensateViscosity:
        underSaturatedCondensateViscosityIntermediates
    },
    params
  };
}
